// extracted by mini-css-extract-plugin
module.exports = {"content":"fields_content__2f7_m","center":"fields_center__3xICT","flex":"fields_flex__1h6as","font":"fields_font__3XnQo"};